import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, MSquare, Calendar, Search, X, Filter } from "lucide-react";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import {
  FetchTimesheetApi,
  FetchTimesheetHoursClickApi,
  fetchDashboardData,
  FetchApprovalsApi,
} from "../../actioncreators/actioncreators";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  imagedata,
  timeentries,
  workedhours,
  approvaldata,
} from "../../actions/loanAction";
// import ArthaTRACK from "../../Assets/LOGO.png";
import TimeEntries from "./TimeEntries";
// import Members from "./Member";
// import AddWorkSchedule from "./AddWorkSchedule";
// import AddWorkLocation from "./AddWorkLocation";
import "./dashboard.css";
// import LocationTracking from "./LocationTracking";
import ArthaContinueButton from "../../fields/ArthaContinueButton";
import ArthaCancelButton from "../../fields/ArthaCancelButton";
// import AppUsage from "./AppUsage";
import ApprovalTimeEntries from "./ApprovalTimeEntries";
const Timesheets = () => {
  const navigate = useNavigate();
  const isMountedRef = useRef(false); // Track if component is mounted
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [timesheetData, setTimesheetData] = useState([]);
  const [originalTimesheetData, setOriginalTimesheetData] = useState([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setresponse] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [selectedTab1, setSelectedTab1] = useState("Timesheet");
  const [approvalResponse, setApprovalResponse] = useState("Approvals");
  const [showApprovalContent, setShowApprovalContent] = useState("Approvals");

  // Filter states
  const [memberNameFilter, setMemberNameFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  // Role filter states
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  // Get global location filter from Redux
  const globalLocationFilter = useSelector((state) => state.selectedLocationFilter);
  // Get Super Admin selected organization from Redux
  const superAdminSelectedOrgId = useSelector((state) => state.superAdminSelectedOrgId);
  // Get user role from Redux
  const loginResponse = useSelector((state) => state.loginResponse);
  const isSuperAdmin = loginResponse?.role_name?.toUpperCase() === 'SUPER_ADMIN' || loginResponse?.roleName?.toUpperCase() === 'SUPER_ADMIN';

  const tabs = ["Timesheet", "Approvals"];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const getCurrentWeekSunday = (date) => {
    const monday = new Date(date);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6); // Sunday is 6 days after Monday
    return sunday.toISOString().split("T")[0]; // Return in YYYY-MM-DD format
  };
  const getCurrentWeekMonday = (date) => {
    const currentDate = new Date(date); // Convert input to Date object
    const dayOfWeek = currentDate.getDay(); // Get the current day of the week (0 = Sunday, 6 = Saturday)
    const diff = currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Calculate difference to Monday
    const monday = new Date(currentDate.setDate(diff)); // Set the date to the Monday of the week
    return monday.toISOString().split("T")[0]; // Return the date in YYYY-MM-DD format
  };

  const [mondayDate, setMondayDate] = useState(
    getCurrentWeekMonday(new Date())
  );
  useEffect(() => {
    const newMondayDate = getCurrentWeekMonday(selectedDate);
    const newSundayDate = getCurrentWeekSunday(selectedDate);
    setMondayDate(newMondayDate);
    setSundayDate(newSundayDate);
  }, [selectedDate]);

  // Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCalendar && !event.target.closest('.react-datepicker-wrapper') && 
          !event.target.closest('.react-datepicker-popper') &&
          !event.target.closest('.react-datepicker')) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar]);

  const fetchTimesheetData = async (monday, page = currentPage, size = pageSize, roleId = selectedRole, status = statusFilter) => {
    setIsLoading(true);
    setError(null);
    let isDispatched = false; // Flag to track dispatch status

    // Determine org_id to pass for Super Admin
    const effectiveOrgId = isSuperAdmin && superAdminSelectedOrgId ? superAdminSelectedOrgId : null;

    try {
      const response = await FetchTimesheetApi(monday, page, size, roleId, status, globalLocationFilter, effectiveOrgId);

      if (
        response.data.businessStatusCode === 2 &&
        response.data.httpResponseCode === 200
      ) {
        // Check if summaryData is null or empty
        if (!response.data.summaryData || response.data.summaryData.length === 0) {
          // Clear the data and show empty state
          setTimesheetData([]);
          setOriginalTimesheetData([]);
          setCurrentPage(1);
          setTotalPages(0);
          setTotalRecords(0);
          return;
        }

        setTimesheetData(response.data.summaryData);
        setOriginalTimesheetData(response.data.summaryData);
        
        // Update pagination state from API response
        setCurrentPage(response.data.currentIndex || 1);
        setTotalPages(response.data.totalPages || 1);
        setTotalRecords(response.data.totalRecords || 0);
        const summaryData = response.data.summaryData;

        const workedHours = summaryData.map((employee) => {
          // Assuming employee.daily exists and returning the dailyHours array
          const dailyHours = employee.daily.map((day) => {
            if (day.isRestDay) {
              return "Rest";
            } else {
              // Format workedHours if it exists, otherwise fallback to totalHours or default
              const hours = day.workedHours || "0h 0m";
              return hours;
            }
          });

          // Return the array of daily hours for the employee
          return dailyHours;
        });

        // Only dispatch workedHours if it hasn't been dispatched before
        if (!isDispatched) {
          dispatch(workedhours(workedHours));
          isDispatched = true; // Set the flag to true after dispatching
        }
      } else {
        throw new Error("");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchApprovalsData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const payload = {
        pageNumber: 1,
        pageSize: 20,
        date: mondayDate, // Use the current week's Monday date
      };
      const response = await FetchApprovalsApi(payload);
      console.log("approvalresponse", response);
      setApprovalResponse(response?.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabClick = (tabName) => {
    setSelectedTab1(tabName); // Ensure the selected tab is updated
    if (tabName === "Timesheet") {
      fetchTimesheetData(mondayDate);
    } else if (tabName === "Approvals") {
      fetchApprovalsData();
    }
  };

  // Handle member name filter change (client-side filtering)
  const handleMemberNameChange = (value) => {
    setMemberNameFilter(value);
    // Apply client-side filtering
    if (value) {
      const filtered = originalTimesheetData.filter(employee =>
        employee.fullName.toLowerCase().includes(value.toLowerCase())
      );
      setTimesheetData(filtered);
    } else {
      setTimesheetData(originalTimesheetData);
    }
  };

  // Handle status filter change
  const handleStatusChange = (value) => {
    setStatusFilter(value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Handle role filter change
  const handleRoleChange = (roleId) => {
    setSelectedRole(roleId);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // Helper function to format name to show first name + first letter of next word
  // Helper function to get status icon only (no avatar)
  const getStatusIcon = (status) => {
    if (status === "CHECKIN") {
      return (
        <div
          style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            backgroundColor: '#10b981',
            border: '2px solid #ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
          }}
          title="Checked In"
        >
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
            <path d="M11 8L8 11L5 8M8 11V4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      );
    } else if (status === "CHECKOUT") {
      return (
        <div
          style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            backgroundColor: '#ef4444',
            border: '2px solid #ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
          }}
          title="Checked Out"
        >
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
            <path d="M5 8L8 5L11 8M8 5V12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            backgroundColor: '#9ca3af',
            border: '2px solid #ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
          }}
          title="Inactive"
        >
          <svg width="8" height="8" viewBox="0 0 16 16" fill="none">
            <path d="M8 8h.01M8 8v.01" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </div>
      );
    }
  };

  const handleHoursClick = async (date, memberId) => {
    const payload = {
      date: date, // The clicked day's date
      userId: memberId, // The clicked user's ID
    };

    try {
      const response = await FetchTimesheetHoursClickApi(
        payload.date,
        payload.userId
      );
      setresponse(response.data);

      // Find the specific timesheet record for the memberId
      const matchingRecord = timesheetData.find(
        (record) => record.memberId === memberId
      );

      const { fullName, imageData, workedHours,totalBreakHours,totalOverTime,totalWorkedHours } = matchingRecord;

      if (matchingRecord) {
        const body = {
          timeentries: response.data.timeEntries,
          weekStart: mondayDate,
          weekEnd: sundayDate,
          selectedDate: date,
          selectedIndex: timesheetData.indexOf(matchingRecord),
          totalBreakHours:totalBreakHours,
          totalOverTime:totalOverTime,
          totalWorkedHours:totalWorkedHours,
        };

        // Dispatch the worked hours for this specific record
        dispatch(timeentries(body));

        dispatch(imagedata({ fullName, imageData }));
        navigate("/home/timeentries");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [sundayDate, setSundayDate] = useState(
    getCurrentWeekSunday(new Date())
  );

  // Get the current week's Sunday date
  const getWeekDates = (mondayDate) => {
    const weekDates = [];
    let currentDate = new Date(mondayDate);

    for (let i = 0; i < 7; i++) {
      weekDates.push(currentDate.getDate()); // Push only the day number (1-31)
      currentDate.setDate(currentDate.getDate() + 1); // Move to next day
    }

    return weekDates;
  };

  // Handle the next week button click
  const weekDates = getWeekDates(mondayDate); // Get all week dates based on Monday

  // Extract unique roles from timesheet data when it changes
  useEffect(() => {
    if (timesheetData && timesheetData.length > 0) {
      const uniqueRoles = [];
      const roleMap = new Map();
      
      timesheetData.forEach((employee) => {
        if (employee.roleId && employee.roleName && !roleMap.has(employee.roleId)) {
          roleMap.set(employee.roleId, true);
          uniqueRoles.push({
            role_id: employee.roleId,
            role_name: employee.roleName
          });
        }
      });
      
      if (uniqueRoles.length > 0) {
        setRoles(uniqueRoles);
      }
    }
  }, [timesheetData]);

  useEffect(() => {
    if (selectedTab1 === "Timesheet") {
      fetchTimesheetData(mondayDate, currentPage, pageSize, selectedRole, statusFilter);
    } else if (selectedTab1 === "Approvals") {
      fetchApprovalsData();
    }
  }, [mondayDate, currentPage, selectedRole, statusFilter, globalLocationFilter, superAdminSelectedOrgId]);

  const handlePreviousWeek = () => {
    const prevMonday = new Date(mondayDate);
    prevMonday.setDate(prevMonday.getDate() - 7); // Move to the previous Monday
    setMondayDate(prevMonday.toISOString().split("T")[0]); // Update Monday

    // Update Sunday date
    const prevSunday = new Date(prevMonday);
    prevSunday.setDate(prevSunday.getDate() + 6); // Move to the next Sunday
    setSundayDate(prevSunday.toISOString().split("T")[0]); // Update Sunday
  };

  // Handle calendar date selection - only allows selecting one week at a time
  const handleCalendarChange = (date) => {
    if (date) {
      // Calculate the Monday of the selected week
      const selectedMonday = getCurrentWeekMonday(date);
      const selectedMondayDate = new Date(selectedMonday);
      const selectedSunday = getCurrentWeekSunday(selectedMondayDate);
      
      // Only update if the date is not in the future
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const checkDate = new Date(date);
      checkDate.setHours(0, 0, 0, 0);
      
      if (checkDate <= today) {
        setMondayDate(selectedMonday);
        setSundayDate(selectedSunday);
        setSelectedDate(new Date(selectedMonday));
        setShowCalendar(false);
      }
    }
  };

  // Custom day class for highlighting the selected week
  const getDayClassName = (date) => {
    const currentMonday = new Date(mondayDate);
    const currentSunday = new Date(sundayDate);
    const checkDate = new Date(date);
    
    // Reset time to compare only dates
    currentMonday.setHours(0, 0, 0, 0);
    currentSunday.setHours(0, 0, 0, 0);
    checkDate.setHours(0, 0, 0, 0);
    
    if (checkDate >= currentMonday && checkDate <= currentSunday) {
      return "selected-week-day";
    }
    return "";
  };

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const getCurrentWeekDates = () => {
    const today = new Date();
    const currentDay = today.getDay(); // Get the current day (0 is Sunday, 1 is Monday, etc.)

    // Get the difference to the most recent Monday
    const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay; // If today is Sunday (0), go back 6 days
    const currentMonday = new Date(
      today.setDate(today.getDate() + diffToMonday)
    ); // Set the date to this week's Monday
    const currentSunday = new Date(currentMonday); // Copy Monday date to calculate Sunday
    currentSunday.setDate(currentMonday.getDate() + 6); // Set Sunday to be 6 days after Monday

    setMondayDate(currentMonday.toISOString().split("T")[0]);
    setSundayDate(currentSunday.toISOString().split("T")[0]);
  };

  // Function to handle the next week button click
  const handleNextWeek = () => {
    const nextMonday = new Date(mondayDate);
    nextMonday.setDate(nextMonday.getDate() + 7); // Move to the next Monday
    setMondayDate(nextMonday.toISOString().split("T")[0]); // Update Monday

    // Update Sunday date
    const nextSunday = new Date(nextMonday);
    nextSunday.setDate(nextSunday.getDate() + 6); // Move to the next Sunday
    setSundayDate(nextSunday.toISOString().split("T")[0]); // Update Sunday
  };

  // Disable "Next Week" button if it's the current week
  const isNextWeekDisabled = () => {
    const today = new Date();
    const todayMonday = new Date(mondayDate); // Get the current displayed Monday
    todayMonday.setDate(todayMonday.getDate() + 7); // Move it to next Monday

    return today < todayMonday; // Disable "Next Week" if today is before the next Monday
  };

  useEffect(() => {
    getCurrentWeekDates(); // Initialize with the current week's dates
  }, []); // Empty dependency array ensures this runs once when the component mounts

  const parseTime = (timeString) => {
    const [hours, minutes] = timeString.match(/\d+/g) || [0, 0];
    return {
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
    };
  };

  const handleApprovalRowClick = async (employee) => {
    console.log("employee", employee);
    const payload = {
      date: mondayDate, // Use the current week's Monday date
      userId: employee.user_id, // The clicked user's ID
    };

    try {
      const response = await FetchTimesheetHoursClickApi(
        payload.date,
        payload.userId
      );
      setresponse(response.data);
      dispatch(approvaldata(response.data));
      const body = {
        timeentries: employee.daily,
        weekStart: mondayDate,
        weekEnd: sundayDate,
        selectedDate: mondayDate,
        selectedIndex: approvalResponse?.indexOf(employee),
        totalWorkedHours: employee.totalWorkedHours,
        totalBreakHours: employee.totalBreakHours,
      };
      console.log("body", body);
      // Dispatch the worked hours for this specific record
      dispatch(timeentries(body));

      dispatch(
        imagedata({
          fullName: employee.full_name,
        })
      );
      navigate("/home/approvaltimeentries");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [isApproveDialogOpen, setIsApproveDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleApproveConfirm = () => {
    // Add your approve logic here
    setIsApproveDialogOpen(false);
  };

  // Helper function to check if a date is current, past, or future
  const getDateStatus = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(dateString);
    checkDate.setHours(0, 0, 0, 0);
    
    if (checkDate.getTime() === today.getTime()) {
      return 'current';
    } else if (checkDate < today) {
      return 'past';
    } else {
      return 'future';
    }
  };

  // Add this CSS class to your dashboard.css file or use inline styles
  // All users are scrollable in table, header fixed, pagination at bottom
  const tableStyles = {
    outerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(87vh - 120px)', // Fixed height to prevent main screen scroll
      margin: '16px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      overflow: 'hidden'
    },
    tableContainer: {
      flex: 1,
      overflow: 'auto',
      msOverflowStyle: 'thin',
      scrollbarWidth: 'thin',
      border: '1px solid #e5e7eb',
      borderBottom: 'none',
      borderRadius: '12px 12px 0 0'
    },
    table: {
      width: '100%',
      backgroundColor: '#ffffff',
      borderCollapse: 'separate',
      borderSpacing: 0,
      fontSize: '12px'
    },
    thead: {
      position: 'sticky',
      top: 0,
      backgroundColor: '#f8f9fa',
      zIndex: 1,
      fontSize: '12px',
      borderBottom: '2px solid #e5e7eb'
    },
    paginationFixed: {
      fontSize: '12px',
      backgroundColor: '#f9fafb',
      flexShrink: 0,
      border: '1px solid #e5e7eb',
      borderRadius: '0 0 12px 12px',
      padding: '12px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };

  // Show message for Super Admin to select an organization
  if (isSuperAdmin && !superAdminSelectedOrgId) {
    return (
      <div className="p-4 bg-gray-50 min-h-screen" style={{ backgroundColor: "#EFF0F4", minHeight: '80vh' }}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Timesheets</h1>
            <p className="text-sm text-gray-1000">Super Admin View</p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-sm p-12 mt-8">
          <div className="text-amber-1000 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Select an Organization</h2>
          <p className="text-gray-1000 text-center max-w-md">
            Please select an organization from the dropdown in the header to view its timesheets.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0 m-0 text-sm" style={{ fontSize: '12px', minHeight: '80vh', backgroundColor: "#EFF0F4" }}>
      {/* Main Content */}
      <div className="row h-100">
        <main
          className="flex-1 overflow-none border text-black-50 shadow"
          style={{ backgroundColor: "#EFF0F4", height: '87vh' }}
        >
          <>
            <div className="flex justify-between items-center">
              <div className="space-x-4 border-bottom text-black-50 w-full flex" style={{ fontSize: '12px' }}>
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => handleTabClick(tab)} // Use handleTabClick here
                    disabled={tab === "Approvals"}
                    style={{
                      transition: "background-color 0.3s, color 0.3s",
                      borderBottom:
                        selectedTab1 === tab ? "2px solid #fd5f07" : "none", // Apply border only to selected tab
                      marginLeft: "5px",
                      borderRadius: "0px",
                      color: tab === "Approvals" ? "#9ca3af" : (selectedTab1 === tab ? "#fd5f07" : "#000000"), // Color based on selected tab
                      cursor: tab === "Approvals" ? "not-allowed" : "pointer",
                      opacity: tab === "Approvals" ? 0.5 : 1
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {selectedTab1 === "Timesheet" && (
              <>
                {/* Date Range and Filters */}
                <div className="flex justify-between items-center border-bottom text-black-50" style={{ padding: '12px 16px', gap: '12px', flexWrap: 'wrap' }}>
                  <div className="flex items-center gap-3">
                    <span className="text-sm font-bold" style={{ fontSize: '12px' }}>Weekly Timesheets</span>
                    <button
                      onClick={handlePreviousWeek}
                      className="p-2 rounded-full"
                      style={{color: '#fc5d08',border:'1px solid #fc5d08'}}
                    >
                      <ChevronLeft size={14} />
                    </button>

                    <button
                      onClick={handleNextWeek}
                      className="p-2 rounded-full"
                      disabled={isNextWeekDisabled()}
                      style={{color: '#fc5d08',border:'1px solid #fc5d08'}}
                    >
                      <ChevronRight size={14} />
                    </button>

                    <div style={{ position: 'relative' }}>
                      <div 
                        className="flex items-center text-sm font-bold p-2 border rounded" 
                        style={{ fontSize: '12px', cursor: 'pointer', backgroundColor: showCalendar ? '#fff5f0' : '#ffffff' }}
                        onClick={() => setShowCalendar(!showCalendar)}
                      >
                        <Calendar size={16} className="mr-2" />
                        <span>
                          {new Date(mondayDate).toLocaleString("default", {
                            month: "short",
                          })}{" "}
                          {new Date(mondayDate).getDate()} -{" "}
                          {new Date(sundayDate).toLocaleString("default", {
                            month: "short",
                          })}{" "}
                          {new Date(sundayDate).getDate()}
                        </span>
                      </div>
                      
                      {showCalendar && (
                        <div 
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            zIndex: 1000,
                            marginTop: '8px',
                            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                            borderRadius: '8px',
                            overflow: 'hidden'
                          }}
                        >
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleCalendarChange}
                            inline
                            calendarStartDay={1}
                            dayClassName={getDayClassName}
                            showWeekNumbers={false}
                            maxDate={new Date()}
                            selectsRange={false}
                            filterDate={(date) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0);
                              const checkDate = new Date(date);
                              checkDate.setHours(0, 0, 0, 0);
                              return checkDate <= today;
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Inline Filters */}
                  <div className="flex items-center gap-3">
                    {/* Member Name Filter */}
                    <div style={{ position: 'relative', minWidth: '200px' }}>
                      <input
                        type="text"
                        value={memberNameFilter}
                        onChange={(e) => handleMemberNameChange(e.target.value)}
                        placeholder="Search by name..."
                        style={{
                          width: '100%',
                          padding: '8px 12px',
                          paddingLeft: '32px',
                          fontSize: '12px',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          outline: 'none',
                          transition: 'border-color 0.2s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#fc5d08'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                      />
                      <Search 
                        size={14} 
                        style={{ 
                          position: 'absolute', 
                          left: '10px', 
                          top: '50%', 
                          transform: 'translateY(-50%)',
                          color: '#9ca3af'
                        }} 
                      />
                    </div>

                    {/* Role Filter */}
                    <select
                      value={selectedRole}
                      onChange={(e) => handleRoleChange(e.target.value)}
                      style={{
                        minWidth: '150px',
                        padding: '8px 12px',
                        fontSize: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        outline: 'none',
                        backgroundColor: '#ffffff',
                        cursor: 'pointer',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#fc5d08'}
                      onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                    >
                      <option value="">All Roles</option>
                      {roles.map((role) => (
                        <option key={role.role_id} value={role.role_id}>
                          {role.role_name}
                        </option>
                      ))}
                    </select>

                    {/* Status Filter */}
                    <select
                      value={statusFilter}
                      onChange={(e) => handleStatusChange(e.target.value)}
                      style={{
                        minWidth: '150px',
                        padding: '8px 12px',
                        fontSize: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        outline: 'none',
                        backgroundColor: '#ffffff',
                        cursor: 'pointer',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#fc5d08'}
                      onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                    >
                      <option value="">All Status</option>
                      <option value="CHECKIN">Checked In</option>
                      <option value="CHECKOUT">Checked Out</option>
                    </select>

                    {/* Clear Filters Icon */}
                    {(memberNameFilter || statusFilter || selectedRole) && (
                      <button
                        onClick={() => {
                          setMemberNameFilter("");
                          setStatusFilter("");
                          setSelectedRole("");
                          setTimesheetData(originalTimesheetData);
                          setCurrentPage(1);
                        }}
                        style={{
                          padding: '8px',
                          fontSize: '12px',
                          color: '#6b7280',
                          backgroundColor: '#f3f4f6',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        title="Clear filters"
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#e5e7eb';
                          e.currentTarget.style.color = '#374151';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#f3f4f6';
                          e.currentTarget.style.color = '#6b7280';
                        }}
                      >
                        <X size={16} />
                      </button>
                    )}
                  </div>
                </div>

                {/* Timesheet Table */}
                {isLoading ? (
                  <div className="text-center py-8">Loading...</div>
                ) : error ? (
                  <div className="text-center text-red-1000 py-8">{error}</div>
                ) : timesheetData.length === 0 ? (
                  <div className="rounded-lg" style={{ backgroundColor: "#ffffff", boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)', margin: '16px', padding: '48px 16px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <div>
                        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '8px' }}>No timesheet data found</h3>
                        <p style={{ fontSize: '14px', color: '#6b7280' }}>
                          {(memberNameFilter || statusFilter || selectedRole) 
                            ? 'No records match your current filters. Try adjusting your search criteria.'
                            : 'No timesheet records available for the selected week.'}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={tableStyles.outerWrapper}>
                    {/* Scrollable Table Container */}
                    <div style={tableStyles.tableContainer}>
                      <table style={tableStyles.table} className="rounded">
                        <thead style={tableStyles.thead}>
                          <tr className="text-sm" style={{ fontSize: '12px' }}>
                            <th className="px-6 py-3 text-left" style={{ fontWeight: '600', color: '#374151', minWidth: '180px' }}>Employee</th>
                            {[
                              "Mon",
                              "Tue",
                              "Wed",
                              "Thu",
                              "Fri",
                              "Sat",
                              "Sun",
                            ].map((day, index) => {
                              const date = new Date(mondayDate);
                              date.setDate(date.getDate() + index);
                              const dateString = date.toISOString().split("T")[0];
                              const isCurrentDay = getDateStatus(dateString) === 'current';
                              
                              return (
                                <th 
                                  key={day} 
                                  className="px-4 py-3 text-center"
                                  style={{
                                    backgroundColor: isCurrentDay ? '#fff3cd' : '#f8f9fa',
                                    fontWeight: '600',
                                    color: isCurrentDay ? '#fd5f07' : '#374151',
                                    minWidth: '100px',
                                    borderLeft: '1px solid #f3f4f6'
                                  }}
                                >
                                  <div style={{ marginBottom: '4px' }}>{day}</div>
                                  <div 
                                    className="text-xs" 
                                    style={{ 
                                      fontSize: '11px',
                                      fontWeight: isCurrentDay ? '600' : '1000',
                                      color: isCurrentDay ? '#fd5f07' : '#6b7280'
                                    }}
                                  >
                                    {weekDates[index]}
                                  </div>
                                </th>
                              );
                            })}
                            <th className="px-4 py-3 text-center" style={{ fontWeight: '600', color: '#374151', minWidth: '100px', borderLeft: '1px solid #f3f4f6', backgroundColor: '#f8f9fa' }}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {timesheetData.map((employee, empIndex) => (
                            <tr 
                              key={employee.personId} 
                              className="border-t"
                              style={{
                                backgroundColor: empIndex % 2 === 0 ? '#ffffff' : '#f9fafb',
                                transition: 'background-color 0.2s',
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = empIndex % 2 === 0 ? '#ffffff' : '#f9fafb'}
                            >
                              {/* Employee Name */}
                              <td className="px-6 py-3">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  {getStatusIcon(employee.currentStatus)}
                                  <span
                                    className="text-sm font-medium"
                                    style={{ fontSize: '12px', color: '#111827', fontWeight: '500' }}
                                    title={employee.fullName || ''}
                                  >
                                    {employee.fullName || '-'}
                                  </span>
                                </div>
                              </td>

                              {/* Map over the daily data if it's an array */}
                              {Array.isArray(employee.daily) ? (
                                employee.daily.map((day, index) => {
                                  // Calculate the date for the clicked day
                                  const date = new Date(mondayDate);
                                  date.setDate(date.getDate() + index);
                                  const dateString = date.toISOString().split("T")[0];
                                  const isCurrentDay = getDateStatus(dateString) === 'current';
                                  const dateStatus = getDateStatus(dateString);

                                  return (
                                    <td
                                      key={index}
                                      className="px-4 py-3 text-center text-sm cursor-pointer"
                                      onClick={() =>
                                        handleHoursClick(
                                          dateString,
                                          employee.memberId
                                        )
                                      }
                                      style={{ 
                                        fontSize: '12px',
                                        backgroundColor: isCurrentDay ? '#fff3cd' : 'transparent',
                                        fontWeight: isCurrentDay ? '600' : '1000',
                                        borderLeft: '1px solid #f3f4f6',
                                        transition: 'all 0.2s'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (!day.isRestDay) {
                                          e.currentTarget.style.backgroundColor = isCurrentDay ? '#ffe69c' : '#e5e7eb';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = isCurrentDay ? '#fff3cd' : 'transparent';
                                      }}
                                    >
                                      {day.isRestDay ? (
                                        <span 
                                          className="inline-flex rounded-full px-3 py-1 text-xs font-semibold" 
                                          style={{ 
                                            fontSize: '11px',
                                            backgroundColor: '#e5e7eb',
                                            color: '#6b7280'
                                          }}
                                        >
                                          Rest
                                        </span>
                                      ) : (
                                        (() => {
                                          const workedHours = day.workedHours || "0h 0m";
                                          if (workedHours === "0h 0m") {
                                            if (dateStatus === 'past') {
                                              return (
                                                <span style={{ 
                                                  color: '#dc3545', 
                                                  fontWeight: '600',
                                                  fontSize: '12px'
                                                }}>
                                                  Absent
                                                </span>
                                              );
                                            } else {
                                              return <span style={{ color: '#9ca3af', fontSize: '14px' }}>-</span>;
                                            }
                                          }
                                          return (
                                            <span style={{ 
                                              color: '#10b981', 
                                              fontWeight: '600',
                                              fontSize: '12px'
                                            }}>
                                              {workedHours}
                                            </span>
                                          );
                                        })()
                                      )}
                                    </td>
                                  );
                                })
                              ) : (
                                <td
                                  colSpan={7}
                                  className="px-4 py-2 text-center text-sm"
                                  style={{ fontSize: '12px' }}
                                >
                                  No data available
                                </td>
                              )}

                              {/* Total worked hours */}
                              <td 
                                className="px-4 py-3 text-center text-sm" 
                                style={{ 
                                  fontSize: '12px', 
                                  color: employee.totalWorkedHours === "0h 0m" || !employee.totalWorkedHours ? '#9ca3af' : '#10b981',
                                  fontWeight: '700',
                                  borderLeft: '1px solid #f3f4f6',
                                  backgroundColor: '#f9fafb'
                                }}
                              >
                                {employee.totalWorkedHours === "0h 0m" || !employee.totalWorkedHours ? "-" : employee.totalWorkedHours}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                      
                    {/* Pagination Controls - Fixed at bottom of table */}
                    {totalRecords > 0 && (
                      <div style={tableStyles.paginationFixed}>
                          <div className="text-sm" style={{ color: '#6b7280' }}>
                            Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalRecords)} of {totalRecords} results
                          </div>
                          
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handlePageChange(1)}
                              disabled={currentPage === 1}
                              style={{
                                padding: '6px 12px',
                                fontSize: '12px',
                                color: currentPage === 1 ? '#9ca3af' : '#fc5d08',
                                backgroundColor: '#ffffff',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              First
                            </button>
                            
                            <button
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                              style={{
                                padding: '6px 10px',
                                fontSize: '12px',
                                color: currentPage === 1 ? '#9ca3af' : '#fc5d08',
                                backgroundColor: '#ffffff',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <ChevronLeft size={16} />
                            </button>
                            
                            <span style={{ 
                              padding: '6px 12px',
                              fontSize: '12px',
                              color: '#111827',
                              fontWeight: '1000'
                            }}>
                              Page {currentPage} of {totalPages}
                            </span>
                            
                            <button
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              style={{
                                padding: '6px 10px',
                                fontSize: '12px',
                                color: currentPage === totalPages ? '#9ca3af' : '#fc5d08',
                                backgroundColor: '#ffffff',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <ChevronRight size={16} />
                            </button>
                            
                            <button
                              onClick={() => handlePageChange(totalPages)}
                              disabled={currentPage === totalPages}
                              style={{
                                padding: '6px 12px',
                                fontSize: '12px',
                                color: currentPage === totalPages ? '#9ca3af' : '#fc5d08',
                                backgroundColor: '#ffffff',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              Last
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                )}
              </>
            )}

            {selectedTab1 === "Approvals" && (
              <>
                {/* Date Range and Export */}
                <div className="flex justify-between items-center border-bottom text-black-50">
                  <div className="flex items-center ms-3">
                    <button
                      onClick={handlePreviousWeek}
                      className="p-2  rounded-full ml-5"
                      style={{color: '#fc5d08',border:'1px solid #fc5d08'}}
                    >
                      <ChevronLeft size={14} />
                    </button>

                    {/* Next Week Button */}
                    <button
                      onClick={handleNextWeek}
                      className="p-2  rounded-full m-3"
                      disabled={isNextWeekDisabled()}
                      style={{color: '#fc5d08',border:'1px solid #fc5d08'}}
                    >
                      <ChevronRight size={14} />
                    </button>

                    <div style={{ position: 'relative' }}>
                      <div 
                        className="flex items-center text-sm font-bold p-2 border rounded" 
                        style={{ fontSize: '12px', cursor: 'pointer', backgroundColor: showCalendar ? '#fff5f0' : '#ffffff' }}
                        onClick={() => setShowCalendar(!showCalendar)}
                      >
                        <Calendar size={16} className="mr-2" />
                        <span>
                          {new Date(mondayDate).toLocaleString("default", {
                            month: "short",
                          })}{" "}
                          {new Date(mondayDate).getDate()} -{" "}
                          {new Date(sundayDate).toLocaleString("default", {
                            month: "short",
                          })}{" "}
                          {new Date(sundayDate).getDate()}
                        </span>
                      </div>
                      
                      {showCalendar && (
                        <div 
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            zIndex: 1000,
                            marginTop: '8px',
                            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                            borderRadius: '8px',
                            overflow: 'hidden'
                          }}
                        >
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleCalendarChange}
                            inline
                            calendarStartDay={1}
                            dayClassName={getDayClassName}
                            showWeekNumbers={false}
                            maxDate={new Date()}
                            selectsRange={false}
                            filterDate={(date) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0);
                              const checkDate = new Date(date);
                              checkDate.setHours(0, 0, 0, 0);
                              return checkDate <= today;
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Timesheet Table */}
                {isLoading ? (
                  <div className="text-center">Loading...</div>
                ) : error ? (
                  <div className="text-center text-red-1000">{error}</div>
                ) : (
                  <div
                    className="rounded-lg shadow overflow-x-auto"
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    <table
                      className="w-full"
                      style={{ backgroundColor: "#f6f8fb", fontSize: '12px' }}
                    >
                      <thead>
                        <tr className="text-sm text-black-1000" style={{ fontSize: '12px' }}>
                          <th className="px-4 py-2 text-left">Employee</th>
                          {/* <th className="px-4 py-2 text-left">Email</th> */}
                          <th className="px-4 py-2 text-left">Tracked hours</th>
                          <th className="px-4 py-2 text-left">Worked Hours</th>
                          <th className="px-4 py-2 text-left">Breaks</th>
                          <th className="px-4 py-2 text-left">Overtime</th>
                          <th className="px-4 py-2 text-left">Status</th>
                          <th
                            className="px-4 py-2 text-left"
                            style={{ marginLeft: "60px" }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {approvalResponse &&
                          approvalResponse?.map((employee) => (
                            <tr key={employee.personId} className="border-t transition-colors duration-200" style={{ fontSize: '12px' }}>
                              {/* Employee Name */}
                              <td className="px-4 py-2 flex items-center space-x-2">
                                <span className="text-sm text-black" style={{ fontSize: '12px' }}>
                                  {employee.fullName}
                                </span>
                              </td>
                              {/* <td className="px-4 py-2 text-left text-sm  text-black">
                                {employee.email || ""}
                              </td> */}
                              <td className="px-4 py-2 text-left text-sm text-black" style={{ fontSize: '12px' }}>
                                {(() => {
                                  const totalWorked = parseTime(
                                    employee.totalWorkedHours || "0h 0m"
                                  );
                                  const totalBreak = parseTime(
                                    employee.totalBreakHours || "0h 0m"
                                  );

                                  const totalMinutes =
                                    totalWorked.minutes + totalBreak.minutes;
                                  const totalHours =
                                    totalWorked.hours +
                                    totalBreak.hours +
                                    Math.floor(totalMinutes / 60);
                                  const remainingMinutes = totalMinutes % 60;

                                  return `${totalHours}h ${remainingMinutes}m`;
                                })()}
                              </td>
                              <td className="px-4 py-2 text-left text-sm text-black" style={{ fontSize: '12px' }}>
                                {employee.totalWorkedHours || "0h 0m"}
                              </td>
                              <td className="px-4 py-2 text-left text-sm text-black" style={{ fontSize: '12px' }}>
                                {employee.totalBreakHours || "0h 0m"}
                              </td>
                              <td className="px-4 py-2 text-left text-sm text-black" style={{ fontSize: '12px' }}>
                                {employee.totalOverTime || "0h 0m"}
                              </td>
                              <td className="px-4 text-left text-black flex text-center space-x-2 my-3 " style={{ fontSize: '12px' }}>
                                {employee.status === "APPROVED" ? (
                                  <>
                                    <FaCheckCircle
                                      className="text-green-1000 "
                                      size={16}
                                    />
                                    <span>Approved</span>
                                  </>
                                ) : (
                                  <>
                                    {/* <FaRegCircle
                                      className="text-gray-400"
                                      size={14}
                                    /> */}
                                    <span>Open</span>
                                  </>
                                )}
                              </td>
                              <td className="px-4 py-2 text-left" style={{ fontSize: '12px' }}>
                                {employee.status !== "APPROVED" ? (
                                  // Circle with a checkmark for unapproved status
                                  // <div
                                  //   className="flex items-center justify-center w-8 h-8 rounded-full bg-success cursor-pointer"
                                  //   title="Approve timesheet"
                                  //   onClick={(e) => {
                                  //     e.stopPropagation();
                                  //     handleApproveClick(employee);
                                  //   }}
                                  // >

                                  //   <svg
                                  //     xmlns="http://www.w3.org/2000/svg"
                                  //     className="h-4 w-4 text-white"
                                  //     fill="none"
                                  //     viewBox="0 0 24 24"
                                  //     stroke="currentColor"
                                  //     strokeWidth="3"
                                  //   >
                                  //     <path
                                  //       strokeLinecap="round"
                                  //       strokeLinejoin="round"
                                  //       d="M5 13l4 4L19 7"
                                  //     />
                                  //   </svg>
                                  // </div>
                                  <div>
                                    <ArthaContinueButton
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleApprovalRowClick(employee);
                                      }}
                                    >
                                      View Details
                                    </ArthaContinueButton>
                                  </div>
                                ) : (
                                  // Circle with a reopen icon for approved status
                                  <div
                                    className="flex items-center justify-center w-8 h-8 rounded-full text-dark cursor-pointer"
                                    title="Reopen timesheet"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      // handleReopenClick(employee);
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 text-white"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M4 4v5h.582a2 2 0 011.316.439l1.867 1.454A2 2 0 0110.418 12H15l5-5m0 0l-5-5m5 5H9.5a2 2 0 00-1.316.439L6.316 9.439A2 2 0 005 9H4"
                                      />
                                    </svg>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </>

          {activeMenu === "Timesheets" &&
            showContent === true &&
            showApprovalContent !== true && (
              <>
                <TimeEntries onBack={() => setShowContent(false)} />
              </>
            )}
          {activeMenu === "Timesheets" &&
            showApprovalContent === true &&
            showContent !== true && (
              <>
                <ApprovalTimeEntries
                  onBack={() => setShowApprovalContent(false)}
                />
              </>
            )}
        </main>
      
      </div>
      <Dialog
        open={isApproveDialogOpen}
        onClose={() => setIsApproveDialogOpen(false)}
        className="text-left"
        style={{ fontSize: '12px' }}
      >
        <DialogTitle>
          Approve timesheets
          <button
            className="absolute top-2 right-2 text-gray-1000 hover:text-gray-700"
            onClick={() => setIsApproveDialogOpen(false)}
          >
            &times;
          </button>
        </DialogTitle>
        <DialogContent>
          <span style={{ fontSize: '12px' }}>
            Are you sure you want to approve {selectedEmployee?.fullName}
            's <br /> timesheets?
          </span>
        </DialogContent>
        <div className="text-center py-2 mb-2">
          <ArthaCancelButton onClick={() => setIsApproveDialogOpen(false)}>
            Cancel
          </ArthaCancelButton>
          <ArthaContinueButton onClick={handleApproveConfirm}>
            Approve
          </ArthaContinueButton>
        </div>
      </Dialog>
    </div>
  );
};

export default Timesheets;
